
import { MapLocation } from '@/types/location';

// N2 Fitness Gym Locations
export const n2FitnessGyms: MapLocation[] = [
  {
    id: 35001,
    name: "N2 Fitness - Riyadh (Shuhada District Male)",
    type: "Gym",
    devices: 3,
    coordinates: [24.780873649047884, 46.734265476302866],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 35002,
    name: "N2 Fitness - Riyadh (Shuhada District Female)",
    type: "Gym",
    devices: 3,
    coordinates: [24.78113171484145, 46.73418615363714],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 35003,
    name: "N2 Fitness - Riyadh (Andalus District Male)",
    type: "Gym",
    devices: 3,
    coordinates: [24.753794329285473, 46.78400284753475],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 35004,
    name: "N2 Fitness - Riyadh (Andalus District Female)",
    type: "Gym",
    devices: 3,
    coordinates: [24.75359929842615, 46.783690463229284],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 35005,
    name: "N2 Fitness - Riyadh (Khalidiyyah District Male)",
    type: "Gym",
    devices: 3,
    coordinates: [24.62310857535567, 46.74985690674703],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 35006,
    name: "N2 Fitness - Riyadh (Qurtuba District Male)",
    type: "Gym",
    devices: 3,
    coordinates: [24.836972582670715, 46.74149229470066],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 35007,
    name: "N2 Fitness - Riyadh (Qurtuba District Female)",
    type: "Gym",
    devices: 3,
    coordinates: [24.836639184159687, 46.74164599369598],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 35008,
    name: "N2 Fitness - Riyadh (ASH SHIFA Male)",
    type: "Gym",
    devices: 3,
    coordinates: [24.54748126667909, 46.68762626257045],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 35009,
    name: "N2 Fitness - Riyadh (ASH SHIFA Female)",
    type: "Gym",
    devices: 3,
    coordinates: [24.547122156828973, 46.68736454287456],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 35010,
    name: "N2 Fitness - Riyadh (Salam Center)",
    type: "Gym",
    devices: 2,
    coordinates: [24.697571808818623, 46.81873491621733],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 35011,
    name: "N2 Fitness - Riyadh (Tohama AL-Malaz Male)",
    type: "Gym",
    devices: 2,
    coordinates: [24.67947509112625, 46.72019286441766],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 35012,
    name: "N2 Fitness - Riyadh (Tohama AL-Malaz Female)",
    type: "Gym",
    devices: 2,
    coordinates: [24.679206510139732, 46.71987308730975],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 35013,
    name: "N2 Fitness - Riyadh (AL-Swuidi Finelook Male)",
    type: "Gym",
    devices: 3,
    coordinates: [24.58097175665535, 46.6174144202411],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 35014,
    name: "N2 Fitness - Riyadh (AL-Swuidi Finelook Female)",
    type: "Gym",
    devices: 3,
    coordinates: [24.58121621786401, 46.6180424687157],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 35015,
    name: "N2 Fitness - Riyadh (AL-Yasmin Male)",
    type: "Gym",
    devices: 2,
    coordinates: [24.80687891277312, 46.660703724385144],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 35016,
    name: "N2 Fitness - Riyadh (AL-Yasmin Female)",
    type: "Gym",
    devices: 2,
    coordinates: [24.806813598627876, 46.660457026739],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 35017,
    name: "N2 Fitness - Riyadh (AL-Mutamarat Male)",
    type: "Gym",
    devices: 2,
    coordinates: [24.667349872413293, 46.682928093252976],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 35018,
    name: "N2 Fitness - Riyadh (AL-Mutamarat Female)",
    type: "Gym",
    devices: 2,
    coordinates: [24.66728162387652, 46.68230582080476],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 35019,
    name: "N2 Fitness - Riyadh (Sahara Mall - Male)",
    type: "Gym",
    devices: 3,
    coordinates: [24.737905269070094, 46.68293627975892],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 35020,
    name: "N2 Fitness - Riyadh (Sahara Mall - Female)",
    type: "Gym",
    devices: 3,
    coordinates: [24.739035598904444, 46.682389109157896],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 35021,
    name: "N2 Fitness - Jeddah (Hamra District Male)",
    type: "Gym",
    devices: 3,
    coordinates: [21.541891637117512, 39.171776564417655],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 35022,
    name: "N2 Fitness - Jeddah (Hamra District Female)",
    type: "Gym",
    devices: 3,
    coordinates: [21.541382685819165, 39.17171219140577],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 35023,
    name: "N2 Fitness - Jeddah (Fayha District Male)",
    type: "Gym",
    devices: 3,
    coordinates: [21.511234861465287, 39.197374720241086],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 35024,
    name: "N2 Fitness - Jeddah (Fayha District Female)",
    type: "Gym",
    devices: 3,
    coordinates: [21.51116287429746, 39.19781077695686],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 35025,
    name: "N2 Fitness - Jeddah (King's Road District Male)",
    type: "Gym",
    devices: 3,
    coordinates: [21.606496412018195, 39.11925090674703],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 35026,
    name: "N2 Fitness - Jeddah (King's Road District Female)",
    type: "Gym",
    devices: 2,
    coordinates: [21.606421824505507, 39.119290528798466],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 35027,
    name: "N2 Fitness - Jeddah (Marwaa District Male)",
    type: "Gym",
    devices: 3,
    coordinates: [21.615773627880518, 39.21379736441766],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 35028,
    name: "N2 Fitness - Jeddah (Marwaa District Female)",
    type: "Gym",
    devices: 3,
    coordinates: [21.61585926820655, 39.2136794387091],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 35029,
    name: "N2 Fitness - Jeddah (Salamh Mall Male)",
    type: "Gym",
    devices: 2,
    coordinates: [21.589506758753032, 39.15772490674702],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 35030,
    name: "N2 Fitness - Jeddah (Salamh Mall Female)",
    type: "Gym",
    devices: 2,
    coordinates: [21.58915759334612, 39.15768199140577],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 35031,
    name: "N2 Fitness - Jeddah (Alrawdah - Male)",
    type: "Gym",
    devices: 2,
    coordinates: [21.561134594895236, 39.15913636441765],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 35032,
    name: "N2 Fitness - Jeddah (Alrawdah - Female)",
    type: "Gym",
    devices: 2,
    coordinates: [21.56072781556883, 39.158812735602964],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 35033,
    name: "N2 Fitness - Jeddah (Al Mohammadiyyah Male)",
    type: "Gym",
    devices: 2,
    coordinates: [21.64021163076952, 39.13233109325298],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 35034,
    name: "N2 Fitness - Jeddah (Al Mohammadiyyah Female)",
    type: "Gym",
    devices: 2,
    coordinates: [21.63919506308569, 39.13229022646538],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 35035,
    name: "N2 Fitness - Dammam (Shati District Male)",
    type: "Gym",
    devices: 2,
    coordinates: [26.45480628882803, 50.119289849076395],
    region: "Eastern",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 35036,
    name: "N2 Fitness - Dammam (Shati District Female)",
    type: "Gym",
    devices: 2,
    coordinates: [26.45468782831116, 50.119523308679184],
    region: "Eastern",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 35037,
    name: "N2 Fitness - Dammam (Faysaliyah District Male)",
    type: "Gym",
    devices: 2,
    coordinates: [26.40559850905303, 50.06960836441766],
    region: "Eastern",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 35038,
    name: "N2 Fitness - Dammam (Faysaliyah District Female)",
    type: "Gym",
    devices: 2,
    coordinates: [26.40569087149681, 50.06959822019498],
    region: "Eastern",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 35039,
    name: "N2 Fitness - Khobar (Aqrabiya - Male)",
    type: "Gym",
    devices: 2,
    coordinates: [26.288919097307105, 50.18951080489983],
    region: "Eastern",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 35040,
    name: "N2 Fitness - Khobar (Aqrabiya - Female)",
    type: "Gym",
    devices: 2,
    coordinates: [26.288693596539964, 50.189710111547896],
    region: "Eastern",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  }
];
